module.exports = __webpack_public_path__ + "img/di_16_DebtGroup.315f9a39.png";